mutation ShortenedUrlDomainSet($input: ShortenedUrlDomainSetInput!) {
    shortenedUrlDomainSet(input: $input) {
        domainId
    }
}
